import React from 'react';

import {
  Flex, HStack, Stack, Text, useToast,
} from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import { login } from 'api/auth';
import { Input, Button } from 'components';
import useUser from 'stores/useUser';
import auth from 'validations/auth';

export default function LoginForm() {
  const { setAccessCode, setUser } = useUser();
  const { push } = useHistory();
  const toast = useToast();
  const form = useForm({
    mode: 'all',
    resolver: auth.firstLogin,
  });

  const {
    register, handleSubmit, setError, formState: { dirtyFields },
  } = form;

  const { mutate, isLoading } = useMutation(login, {
    onSuccess: ({ data }) => {
      setUser(data);
      push('password');
    },
    onError: (error: any) => {
      if (error.errors) {
        error.errors.forEach((err) => {
          if (err.field) {
            setError(err.field, err);
          } else {
            setError(Object.keys(dirtyFields)[0], err);
          }
        });
      } else {
        toast({
          title: 'Ocorreu um erro.',
          description: error.message,
          status: 'error',
          duration: 5000,
          position: 'top-right',
          isClosable: true,
        });
      }
    },
  });

  const onSubmit = (data) => {
    setAccessCode(data.accessCode);
    mutate({ data });
  };

  return (
    <Stack
      width="100%"
      alignItems="center">
      <Text
        variant="2xLargeSemiBold"
        color="secondary.default">Seja bem vindo(a)!
      </Text>
      <Text
        textAlign="center"
        variant="mediumRegular">Insira o código de acesso enviado para o seu e-mail para começar:
      </Text>
      <FormProvider {...form}>
        <Flex
          onSubmit={handleSubmit(onSubmit)}
          pt={6}
          width="100%"
          flexDir="column"
          as="form"
          justifyContent="space-between"
          flex={1}>
          <Stack
            mb={6}
            spacing={5}>
            <Input
              label="Email"
              {...register('email')}
            />
            <Input
              isSecure
              label="Código de Acesso"
              {...register('accessCode')}
            />
          </Stack>
          <HStack
            width="100%"
            justifyContent="space-between">
            <Button
              onClick={() => push('login')}
              flex={1}
              size="xs"
              variant="secondary.teal">
              <Text variant="smallBold">
                Já possuo conta
              </Text>
            </Button>
            <Button
              isLoading={isLoading}
              type="submit"
              size="xs"
              variant="primary.blue">
              <Text variant="smallBold">
                Prosseguir
              </Text>
            </Button>
          </HStack>
        </Flex>
      </FormProvider>
    </Stack>
  );
}
